import * as ReactQuery from 'react-query';
import { UnwrapAsyncReturn } from '../../../utils/types/unwrap-promise';
import { Fusion } from '../../../components/admin/fusion-process/fusion-process-types';
import { editFusionApi } from './api';

export function useEditFusion(params: {
  fusionId: string;
  onSuccess: (data?: UnwrapAsyncReturn<typeof editFusionApi>) => void;
}) {
  const [editFusionDetails, editFusionDetailsMeta] = ReactQuery.useMutation(
    async (data: Fusion) => editFusionApi(params.fusionId, data),
    {
      onSuccess: async () => {
        params.onSuccess();
      },
    },
  );

  return {
    editFusionDetails,
    editFusionDetailsMeta,
  };
}
